export const GOOGLE_API_KEY = 'AIzaSyAH2JCjB8kdw5PcnX_akReXs3chYu1ID4M'
export const BRIGHTCOVE_ACC_ID = '6415869056001'
export const BRIGHTCOVE_PLAYER_ID = 'eUy0Am5Rp'

// This brightcove player hides the fullscreen and download functionality
export const BRIGHTCOVE_PLAYER_ID_ALT = 'aKEYiVRECH'
